import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Percentiles.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Percentiles.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_PERCENTILES_REQUEST,
    });

    $.when(Ajax.PercentilesService())
      .done(function (response) {
        dispatch({
          type: TYPES.FETCH_PERCENTILES_SUCCESS,
          percentiles: response.percentiles,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_PERCENTILES_FAILURE,
        });
      });
  };
};

const Percentiles = {
  fetch: fetch,
};
export { Percentiles };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_PERCENTILES_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_PERCENTILES_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.percentiles),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_PERCENTILES_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    default:
      return state;
  }
};

export { reducer, reducer as default };
